var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-2",attrs:{"flat":"","outlined":""}},[_c('v-card-title',[_vm._v("Fundamentals of Programming (Java Programming)")]),_c('v-card-text',{staticClass:"d-flex"},[_c('p',{staticClass:"mr-6"},[_vm._v("40 Items")]),_c('p',[_vm._v("April 12, 2023")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }